import { Component, Inject, ViewEncapsulation, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CE_SNACKBAR_DATA, CeSnackbarService, SnackbarAction, SnackbarData } from './ce-snackbar.service';
import { slideUpAndDownAnimation } from '../ce-animation/ce-animation.lib';
import { CeIconComponent } from '../ce-icon/ce-icon.component';
import { CeButtonComponent } from '../ce-button/ce-button.component';
import { CeLinkButtonComponent } from '../ce-link-button/ce-link-button.component';
import { CeSpinningLoaderComponent } from '../ce-spinning-loader/ce-spinning-loader.component';

@Component({
    selector: 'ce-snackbar',
    standalone: true,
    imports: [CommonModule, CeIconComponent, CeButtonComponent, CeLinkButtonComponent, CeSpinningLoaderComponent],
    templateUrl: './ce-snackbar.component.html',
    styleUrl: './ce-snackbar.component.scss',
    animations: [slideUpAndDownAnimation],
    encapsulation: ViewEncapsulation.None,
})
export class CeSnackbarComponent {
    readonly #snackbarService = inject(CeSnackbarService);
    state = signal<string>('up');
    snackbarState = signal<string>('default');

    constructor(@Inject(CE_SNACKBAR_DATA) public data: SnackbarData) {
        if (data?.state) {
            this.snackbarState.set(data.state);
        }
    }

    stateClass() {
        return `CeSnackbar--${this.snackbarState()}`;
    }

    close() {
        this.state.set('down');
    }

    handleActionClick(action: SnackbarAction) {
        action.onClick();
    }

    onCloseClick() {
        this.#snackbarService.closeSnackbar();
    }
}
